import React from 'react';
import { Helmet } from 'react-helmet-async';

const Head = ({ children }: { children: React.ReactNode }) => <Helmet>{children}</Helmet>;

export default Head;
